import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const TelephoneIcon = ({
  color = 'foraBlue',
  width = 13,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M3.8 4.755s1.34 2.453 4.02 3.738c0 0 .298.08.633-.23l.523-.468s.356-.506 1.214-.097L12.62 9.02s.858.331 0 1.11l-1.592 1.499s-.355.623-2.135.253c0 0-6.054-1.482-8.693-7.946 0 0-.586-1.168.252-2.102L2.21.187s.716-.547 1.072.231L4.58 2.715s.481.526-.126 1.11l-.544.467c-.035.03-.289.168-.11.463z"
      />
    </svg>
  </DefaultIconWrapper>
);
